import { UserProfileResponseService } from "../../services/user/UserTypes.type";
import { SET_PROFILE_USER, SET_PORTAL_TERMS_ACCEPTED } from "./actionTypes";

export const setProfileUser = (data: UserProfileResponseService) => ({
  type: SET_PROFILE_USER,
  payload: data,
});

export const setPortalTermsAccepted = (accepted: boolean) => ({
  type: SET_PORTAL_TERMS_ACCEPTED,
  payload: accepted,
});
